import { Injectable } from '@angular/core';
import { catchError, Observable, of, switchMap, throwError } from 'rxjs';
import { AppSettingsService } from 'src/app/services/app-settings.service';
import { HttpService } from 'src/app/services/http.service';

@Injectable({
  providedIn: 'root'
})
export class ImportContactService {
  baseEndpoint$: Observable<string> = this.appSettingService.localEnv ? of('http://localhost:7071/api/import-contact/') : of('import-contact/');

  constructor(private http:HttpService,
    private appSettingService: AppSettingsService
  ) { }

  getContactImportTemplate(): Observable<any> {
    return this.baseEndpoint$.pipe(
      switchMap((endpoint) =>
        this.http.downloadFile(`${endpoint}download-template`, 'application/vnd.ms-excel'),
      ),
      catchError((err) => {
        return throwError(() => err);
      })
    );
  }
}
